<template>
    <div class="relative flex flex-col flex-1 min-h-0 bg-stage-background overflow-hidden">
        <div class="stage-page-header">
            <div class="stage-page-header-row">
                <div class="stage-page-header-main">
                    <h1 class="stage-page-title">{{ $t('CMS-Domains') }}</h1>
                </div>
                <div class="stage-page-header-actions">
                    <router-link class="btn-stage-icon-plain" :title="$t('Back')" :aria-label="$t('Back')" to="/workspace/cms">
                        <svg-vue class="h-4 w-4" icon="font-awesome.regular.arrow-left"></svg-vue>
                    </router-link>
                    <router-link class="btn-stage-icon-plain" :title="$t('Domain anlegen')" :aria-label="$t('Domain anlegen')" to="/workspace/cms/domains/new">
                        <svg-vue class="h-4 w-4" icon="font-awesome.regular.plus"></svg-vue>
                    </router-link>
                </div>
            </div>
        </div>

        <div class="stage-page-body stage-page-fill">
            <div class="w-full h-full bg-white shadow sm:rounded relative overflow-hidden flex flex-col min-h-0">
                <loading :status="loading"/>

                <div class="relative flex-1 min-h-0 overflow-hidden">
                    <div class="h-full overflow-auto">
                        <div v-if="domains.length > 0" class="hidden sm:block">
                            <div class="align-middle inline-block min-w-full border-b border-ultralight">
                                <table class="table-listview table-listview--zebra">
                                    <thead>
                                    <tr>
                                        <th class="table-listview-l-th">{{ $t('Domain') }}</th>
                                        <th class="table-listview-l-th">{{ $t('Host') }}</th>
                                        <th class="table-listview-l-th whitespace-nowrap w-24">{{ $t('Pfade') }}</th>
                                        <th class="table-listview-l-th whitespace-nowrap w-48">{{ $t('Erstellt von') }}</th>
                                        <th class="table-listview-l-th whitespace-nowrap w-40">{{ $t('Update') }}</th>
                                    </tr>
                                    </thead>
                                    <tbody class="bg-white">
                                    <tr
                                        v-for="domain in domains"
                                        :key="domain.id"
                                        class="cursor-pointer"
                                        @click="$router.push('/workspace/cms/domains/' + domain.id + '/edit')"
                                    >
                                        <td class="table-listview-l-td whitespace-nowrap">
                                            <div class="flex items-center min-w-0">
                                                <div class="mr-3 flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-gray-700">
                                                    <svg-vue class="w-8 h-8 p-1.5 text-gray-200" icon="font-awesome.regular.plug"></svg-vue>
                                                </div>
                                                <div class="min-w-0">
                                                    <div class="flex items-center gap-2 min-w-0">
                                                        <div class="text-sm font-medium text-gray-900 truncate">{{ domain.name || domain.host }}</div>
                                                        <span :class="domainStatusMeta(domain).dotClass" class="h-2 w-2 rounded-full flex-shrink-0"></span>
                                                    </div>
                                                    <div class="text-xs text-gray-500 mt-1">{{ $t('Token geschützt') }}</div>
                                                </div>
                                            </div>
                                        </td>
                                        <td class="table-listview-l-td whitespace-nowrap text-sm text-gray-700">
                                            {{ domain.host }}
                                        </td>
                                        <td class="table-listview-l-td whitespace-nowrap text-sm text-gray-700">
                                            {{ domain.routes_count }}
                                        </td>
                                        <td class="table-listview-l-td whitespace-nowrap">
                                            <div class="flex items-center min-w-0 max-w-[12rem] text-sm text-gray-500">
                                                <img
                                                    v-if="createdActorAvatar(domain)"
                                                    :src="createdActorAvatar(domain)"
                                                    :alt="createdActorName(domain)"
                                                    :title="createdActorName(domain)"
                                                    class="h-6 w-6 rounded-full border border-white object-cover mr-2 flex-shrink-0"
                                                >
                                                <span class="truncate text-gray-900">{{ createdActorName(domain) }}</span>
                                            </div>
                                        </td>
                                        <td class="table-listview-l-td whitespace-nowrap text-sm text-gray-500">
                                            {{ domain.updated_at ? $momentFormatDateTimeAgo(domain.updated_at) : '-' }}
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div v-else-if="!loading" class="h-full">
                            <empty-state />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    cmsCreatedActorAvatar,
    cmsCreatedActorName,
} from '@/utils/cms-update-meta';
import {cmsActivationStatusMeta} from '@/utils/cms-status-badge';

export default {
    name: "cms-domains-list",
    data() {
        return {
            loading: true,
            domains: [],
        };
    },
    mounted() {
        this.loadDomains();
    },
    methods: {
        createdActorAvatar(domain) {
            return cmsCreatedActorAvatar(domain);
        },
        createdActorName(domain) {
            return cmsCreatedActorName(domain);
        },
        domainStatusMeta(domain) {
            return cmsActivationStatusMeta(this, domain);
        },
        loadDomains() {
            this.loading = true;
            axios.get('api/workspace/admin/cms/domains').then((response) => {
                this.domains = Array.isArray(response.data) ? response.data : [];
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        },
    },
}
</script>
